"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var beginDrag_1 = __importDefault(require("./beginDrag"));
var publishDragSource_1 = __importDefault(require("./publishDragSource"));
var hover_1 = __importDefault(require("./hover"));
var drop_1 = __importDefault(require("./drop"));
var endDrag_1 = __importDefault(require("./endDrag"));
__export(require("./types"));
function createDragDropActions(manager) {
    return {
        beginDrag: beginDrag_1.default(manager),
        publishDragSource: publishDragSource_1.default(manager),
        hover: hover_1.default(manager),
        drop: drop_1.default(manager),
        endDrag: endDrag_1.default(manager),
    };
}
exports.default = createDragDropActions;
